module.exports = {"420105002":"建桥街","420105004":"晴川街","420105005":"鹦鹉街","420105006":"洲头街","420105007":"五里墩街","420105008":"琴断口街","420105009":"江汉二桥街","420105010":"永丰街","420105011":"江堤街","420105012":"四新街","420105013":"龙阳街"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420105.json
// module id = 1701
// module chunks = 0